import React from 'react';
import { StickyBar } from 'seduo-ui';
const Example = () => <StickyBar text="Neomezený přístup ke všem kurzům máte od svého zaměstnavatele"/>;
export default Example;
